import React from 'react';

/**
 * Contexts
 */
const TabContext = React.createContext({
  tab: 'basstrakk',
});

/**
 * Providers
 */
export const TabProvider = TabContext.Provider;

export default TabContext;
